/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MergeUsersPreviewDto } from '../../models/merge-users-preview-dto';
import { MergeUsersPreviewResponse } from '../../models/merge-users-preview-response';

export interface UserControllerMergePreview$Params {
      body: MergeUsersPreviewDto
}

export function userControllerMergePreview(http: HttpClient, rootUrl: string, params: UserControllerMergePreview$Params, context?: HttpContext): Observable<StrictHttpResponse<MergeUsersPreviewResponse>> {
  const rb = new RequestBuilder(rootUrl, userControllerMergePreview.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MergeUsersPreviewResponse>;
    })
  );
}

userControllerMergePreview.PATH = '/user/merge/preview';
